// extracted by mini-css-extract-plugin
export default {"icon":"google-icon-module__icon___TvlBU"};